import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getClientByClient, getModuleById } from '../api';
import { RedirectUrlValue } from '../../context/RedirectUrlValue.js';
import Loading from '../Loading';

export default function Link() {
    
    const { state } = useLocation();
    const [error, setError] = useState(null);
    const [onData, setOnData] = useState("");
    const [module, setModule] = useState({});
    const { brand } = useContext(RedirectUrlValue);
    const navigate = useNavigate();
    const fetchData = async () => {
        try {
            const clientData = await getClientByClient(brand);
            setOnData(clientData);
            const moduleData = await getModuleById(state.module);
            setModule(moduleData);
        } catch (error) {
            setError('Une erreur s\'est produite lors de la récupération des données.');
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (module.url === undefined) {
            console.log("0_0" + module.url)
        } else {
            console.log("true " + module.url)
            window.location.href = module.url
        }
    }, [module])

    if (error) {
        navigate("/");
    }

    return(
        <Loading/>
    )
}